/**
 * Intercepts clicks on configured links when the user is not authenticated,
 * sending them to login with a return URL instead of the link destination.
 *
 * Register rules in app.js (or call initAuthGatedLinks from a page module).
 * Markup can also opt in via data-requires-login + optional data-login-return.
 */
import { redirectToLogin } from '../utils/login-redirect';

const DATA_GATE = 'requiresLogin';
const DATA_RETURN = 'loginReturn';

const resolveReturnUrl = (link, rule) => {
  const dataReturn = (link.getAttribute(`data-${DATA_RETURN}`) || '').trim();
  if (dataReturn) {
    return dataReturn;
  }

  if (typeof rule.getReturnUrl === 'function') {
    return (rule.getReturnUrl(link) || '').trim();
  }

  if (typeof rule.returnUrl === 'string') {
    return rule.returnUrl.trim();
  }

  const href = link.getAttribute('href');
  return href && href !== '#' ? href.trim() : '';
};

const initAuthGatedLinks = (rules = []) => {
  const normalizedRules = Array.isArray(rules) ? rules.filter(r => r && r.selector) : [];

  document.addEventListener('click', (event) => {
    if (window.isAuthenticated) {
      return;
    }

    const link = event.target.closest(`a[data-${DATA_GATE}], ${normalizedRules.map(r => r.selector).join(', ')}`);
    if (!link || link.getAttribute('href') === '#') {
      return;
    }

    const rule = normalizedRules.find(r => link.matches(r.selector));
    const hasDataGate = link.hasAttribute(`data-${DATA_GATE}`);
    if (!rule && !hasDataGate) {
      return;
    }

    const returnUrl = resolveReturnUrl(link, rule || {});
    if (!returnUrl) {
      return;
    }

    event.preventDefault();
    redirectToLogin(returnUrl);
  });
};

export default initAuthGatedLinks;
